import { eraGetProvinceCity, getProductInfo, applyInit, getSaveApplyInfo, resolveApplyNo, getIndustryListForTeamProdApi } from './api';
import { globalData } from './config';
import { getLangData } from './lang';
import { parseSimpleTreeData } from '../utils/formatTreeData';
import {URLSearchParamsForAli} from '../utils/url'
import { message } from 'antd';

interface EXPORT_DATA {
  address: any[],
  appInitData: any,
  appProductInfo: any,
  teamIndustryList?: any[]
}

export async function initApp(props) {
  let result = true;
  const { productCode, aliProductCodes, teamAccidentProds } = globalData;
  const isTeamAccidentProd = teamAccidentProds.includes(productCode);
  const appInitData = await applyInit(productCode); // 流程初始化
  globalData['flowId'] = appInitData.data['flowId']; // 流程号
  // 如果是电商保产品，则需要解密applyNo
  const isAliProduct = aliProductCodes.includes(productCode);
  if (isAliProduct) {
    globalData['gUrlData'] = (URLSearchParamsForAli(window.location.href)) as any
    let isAllowInit = true;
    const gUrlData = globalData['gUrlData'] || {};
    const applyNo = gUrlData['applyNo'] || gUrlData['apply_no'];
    const sign = gUrlData['sign'];
    if (!applyNo || !sign) {
      isAllowInit = false;
    } else {
      const resolveResponse = await resolveApplyNo({
        applyNo,
        sign,
        aliCallback: gUrlData['callbackUrl'],
        timestamp: gUrlData['timestamp'],
        flowId: globalData['flowId'],
        user: gUrlData['user'],
        tracelog: gUrlData['tracelog']
      }).catch((e) => {
        console.error('获取applyNo失败', e);
      });
      const resolveResult = (resolveResponse || {}).data || {};
      if (resolveResult['resultCode'] === '0000') {
        globalData['aliPolicyInfo']['applyNo'] = (resolveResult['data'] || {})['applyNo'] || '';
        isAllowInit = !!globalData['aliPolicyInfo']['applyNo'];
      } else {
        isAllowInit = false;
      }
    }
    if (!isAllowInit) {
      console.error('获取applyNo失败');
    }
  }
  globalData['productName'] = appInitData.data['productName']; // 产品名称
  globalData['effectiveDateFlag'] = appInitData.data['showCertValidity']; // 证件有效期开关
  const cityInfo = await eraGetProvinceCity(); // 获取地区信息
  globalData['dpt'] = cityInfo.data.codeMap;
  const options = parseSimpleTreeData(cityInfo.data.selectList, {
    id: 'districtId',
    pId: 'parentId',
    rootPId: null,
  }); // 序列化地区信息
  let appProductInfo: any = {
    data: { data: '' },
  };
  let teamIndustryList: any = [];
  // 获取投保人信息，然后填入表单默认值
  await getSaveApplyInfo().then((res) => {
    globalData['applicant'] = res['data']['applicant'];
  });
  try {
    // 获取产品信息
    appProductInfo = await getProductInfo({
      cityCode: props.cityCode,
      departmentCode: props.departmentCode,
    }).catch(() => {
      console.error('获取产品信息失败');
    });
    // appProductInfo = await getProductInfo({cityCode: 310119, departmentCode: globalData['dpt']['310100']}) //获取产品信息
  } catch (e) {
    result = false;
  }
  // 团意产品 获取行业信息 （团意产品和小微产品不同，行业信息不配置在套餐中，只能额外掉接口获取）
  if (isTeamAccidentProd) {
    await getIndustryListForTeamProdApi({})
      .then((res: any) => {
        teamIndustryList = res.data || [];
      }).catch(() => {
        console.error('获取团意产品行业信息失败');
      });
  }

  if (!globalData['dpt'] || !appInitData.data || !appProductInfo.data.data || !globalData['flowId']) {
    result = false;
  }
  getLangData(productCode);

  let exportData: EXPORT_DATA = {
    address: options,
    appInitData: appInitData.data,
    appProductInfo: appProductInfo.data.data,
  };

  if (isTeamAccidentProd) {
    exportData['teamIndustryList'] = teamIndustryList;
  }

  return {
    result,
    data: exportData,
  };
}
